<template>
    <table class="table table-bordered table-striped table-vcenter dataTable" style="width: 100%;">
        <thead>
            <tr>
                <th v-if="!hide.includes('customer')">Customer</th>
                <th v-if="!hide.includes('contact')">Contact</th>
                <th v-if="!hide.includes('email')">Email</th>
                <th v-if="!hide.includes('position')">Position</th>
                <th v-if="!hide.includes('address')">Address</th>
                <th v-if="!hide.includes('user')">User</th>
                <th v-if="!hide.includes('actions')">Actions</th>
            </tr>
        </thead>
        <tbody></tbody>
    </table>
</template>

<script>
import { buildColumns } from "@/helpers/build-columns";

export default {
    props: {
        ajaxUrl: String,
        hide: {
            type: Array,
            default: () => [],
            required: false,
        },
        sortIndex: {
            type: Number,
            default: 0,
            required: false,
        }
    },

    data() {
        return {
            columnDefinitions: {
                customer: {
                    name: 'customer.name',
                    searchable: false,
                    orderable: false,
                    render: (data, type, row) => row.computed_customer,
                },
                contact: {
                    data: 'contact_name',
                },
                email: {
                    data: 'contact_email',
                },
                position: {
                    data: 'position',
                    searchable: false,
                },
                address: {
                    data: 'full_address',
                    searchable: false,
                    orderable: false,
                },
                user: {
                    data: 'user',
                    searchable: false,
                    orderable: false,
                    width: '200px',
                },
                actions: {
                    data: 'actions',
                    name: 'actions',
                    searchable: false,
                    orderable: false,
                    width: '200px',
                },
            },
        };
    },

    mounted() {
        window.jQuery(this.$el).dataTable({
            processing: true,
            serverSide: true,
            pageLength: 25,
            lengthMenu: [25, 50, 100],
            ajax: {
                url: this.ajaxUrl,
            },
            order: [[this.sortIndex, 'asc']],
            columns: buildColumns(this.columnDefinitions, this.hide),
        });
    },
};
</script>
